module.exports = __webpack_public_path__ + "static/img/txt-000-kangaeta.3bd824d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/txt-000-kangaeta.svg
// module id = N6fo
// module chunks = 1